(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["syndicated-faqs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pr-syndicated-faqs')) {
    const requests = new Map();
    const normalize = (value) => (value || '').trim().replace(/\s+/g, ' ').toLowerCase();

    function fetchSource(url, editor) {
      const key = `${editor ? 'editor:' : 'storefront:'}${url.href}`;
      if (requests.has(key)) return requests.get(key);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      const pending = fetch(url.href, {
        credentials: 'same-origin',
        cache: editor ? 'no-store' : 'default',
        signal: controller.signal
      }).then(async (response) => {
        if (!response.ok) throw new Error(`Source page returned HTTP ${response.status}.`);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        return Array.from(document.querySelectorAll('[syndicate-faqs]'))
          .filter((node) => !node.closest('pr-syndicated-faqs'));
      }).catch((error) => {
        requests.delete(key);
        throw error;
      }).finally(() => {
        clearTimeout(timeout);
        if (editor) requests.delete(key);
      });
      requests.set(key, pending);
      return pending;
    }

    function prepareClone(source, prefix) {
      const clone = source.cloneNode(true);
      clone.querySelectorAll('script, pr-syndicated-faqs').forEach((node) => node.remove());
      const nodes = [clone, ...clone.querySelectorAll('*')];
      const ids = new Map();
      nodes.forEach((node) => {
        Array.from(node.attributes).forEach(({ name }) => {
          if (name.startsWith('data-shopify-editor-')) node.removeAttribute(name);
        });
        node.removeAttribute('can-reveal');
        if (node.id) {
          const original = node.id;
          node.id = `${prefix}-${original}`;
          ids.set(original, node.id);
        }
      });
      nodes.forEach((node) => {
        ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns', 'headers'].forEach((name) => {
          if (!node.hasAttribute(name)) return;
          node.setAttribute(name, node.getAttribute(name).split(/\s+/).map((id) => ids.get(id) || id).join(' '));
        });
        ['href', 'xlink:href'].forEach((name) => {
          const value = node.getAttribute(name);
          if (value?.startsWith('#') && ids.has(value.slice(1))) node.setAttribute(name, `#${ids.get(value.slice(1))}`);
        });
        Array.from(node.attributes).forEach(({ name, value }) => {
          if (value.includes('url(#')) node.setAttribute(name, value.replace(/url\(#([^)]*)\)/g, (match, id) => ids.has(id) ? `url(#${ids.get(id)})` : match));
        });
      });
      return clone;
    }

    class SyndicatedFaqs extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.querySelector('[data-faq-refresh]')?.addEventListener('click', () => this.load(), options);
        this.querySelector('[data-faq-names]')?.addEventListener('click', (event) => {
          const button = event.target.closest('[data-faq-copy]');
          if (button) this.copyName(button);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const slot = event.target.closest('[data-faq-slot]');
          if (slot) {
            this.selectedSlot = slot;
            slot.scrollIntoView({ block: 'nearest' });
          }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.selectedSlot = null; }, options);
        this.load();
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.version = (this.version || 0) + 1;
      }

      async copyName(button) {
        const name = button.dataset.faqCopy;
        const status = this.querySelector('[data-faq-copy-status]');
        if (status) status.textContent = '';
        try {
          try {
            await navigator.clipboard.writeText(name);
          } catch {
            const field = document.createElement('textarea');
            const focused = document.activeElement;
            field.value = name;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
            document.body.append(field);
            try {
              field.select();
              if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
            } finally {
              field.remove();
              focused?.focus({ preventScroll: true });
            }
          }
          if (status) status.textContent = `Copied “${name}”. Paste it into your FAQ group block.`;
        } catch {
          if (status) status.textContent = `Could not copy automatically. Select and copy “${name}” manually.`;
        }
      }

      renderNames(names) {
        const container = this.querySelector('[data-faq-names]');
        if (!container) return;
        container.replaceChildren(document.createTextNode('Available names: '));
        if (!names.length) {
          container.append('None found. Add syndicate-faqs and syndication-section-name to the source wrappers.');
          return;
        }
        names.forEach((name) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pr-faq-copy';
          button.dataset.faqCopy = name;
          button.setAttribute('aria-label', `Copy ${name}`);
          button.title = 'Copy syndication name';
          button.append(document.createTextNode(name));
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('fill', 'none');
          icon.setAttribute('stroke', 'currentColor');
          icon.setAttribute('stroke-width', '1.7');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('focusable', 'false');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M8 8h12v13H8z M16 8V3H3v13h5');
          icon.append(path);
          button.append(icon);
          container.append(button);
        });
      }

      async load() {
        const version = this.version = (this.version || 0) + 1;
        const editor = this.hasAttribute('data-editor');
        const slots = Array.from(this.querySelectorAll('[data-faq-slot]'));
        const status = this.querySelector('[data-faq-status]');
        const fallback = this.querySelector('[data-faq-fallback]');
        const button = this.querySelector('[data-faq-refresh]');
        if (button) button.disabled = true;
        if (status) status.textContent = 'Loading source page…';
        this.querySelector('[data-faq-names]')?.replaceChildren();
        this.querySelector('[data-faq-copy-status]')?.replaceChildren();
        this.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.dataset.source, location.origin);
          if (url.origin !== location.origin) throw new Error('Choose a page from this store.');
          const previewId = new URLSearchParams(location.search).get('preview_theme_id');
          if (previewId) url.searchParams.set('preview_theme_id', previewId);
          else if (editor && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
          const sources = await fetchSource(url, editor);
          if (!this.isConnected || version !== this.version) return;
          const names = [...new Set(sources.map((node) => node.getAttribute('syndication-section-name')).filter(Boolean))];
          let rendered = 0;
          slots.forEach((slot) => {
            const name = normalize(slot.dataset.faqName);
            const matches = sources.filter((node) => name && normalize(node.getAttribute('syndication-section-name')) === name);
            const content = slot.querySelector('[data-faq-content]');
            const message = slot.querySelector('[data-faq-message]');
            content.replaceChildren();
            if (matches.length === 1) {
              content.append(prepareClone(matches[0], `faq-${this.dataset.sectionId}-${slot.dataset.blockId}`));
              rendered++;
              if (message) message.hidden = true;
            } else if (message) {
              message.hidden = false;
              message.textContent = !name ? 'Enter a syndication section name in this block.'
                : matches.length > 1 ? `More than one source section is named “${slot.dataset.faqName}”. Give each source section a unique name.`
                : `No source section matches “${slot.dataset.faqName}”.`;
            }
          });
          fallback.hidden = slots.length === 0 || rendered === slots.length;
          if (status) status.textContent = `${rendered} of ${slots.length} blocks loaded.${slots.length ? '' : ' Add an FAQ group block to begin.'}`;
          this.renderNames(names);
          this.selectedSlot?.scrollIntoView({ block: 'nearest' });
          this.dispatchEvent(new CustomEvent('pr:faqs:loaded', { bubbles: true }));
        } catch (error) {
          if (!this.isConnected || version !== this.version) return;
          fallback.hidden = false;
          if (status) status.textContent = `FAQs could not be refreshed. ${error.message} Check that the source page is available, then try Refresh FAQs.`;
          slots.forEach((slot) => {
            const message = slot.querySelector('[data-faq-message]');
            if (message) {
              message.hidden = false;
              message.textContent = 'Source unavailable. Any previously loaded FAQs remain visible.';
            }
          });
        } finally {
          if (this.isConnected && version === this.version) {
            this.removeAttribute('aria-busy');
            if (button) button.disabled = false;
          }
        }
      }
    }
    customElements.define('pr-syndicated-faqs', SyndicatedFaqs);
  }

  } catch(e) { console.error(e); }
})();
})();
